import { PagingParams, PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Exeption } from '../models/ExeptionModel';


export default class ExemptionApi {

    private http: HTTPClient;
    private exeptionApi!: string;
    private treatmentApi!: string;

    constructor(http: HTTPClient, exeptionApi: string, treatmentApi: string) {
        this.http = http;
        this.exeptionApi = exeptionApi;
        this.treatmentApi = treatmentApi
    }

    public async getExecutionTypeExeptions(exemptionType: string, councilId: number): Promise<Exeption[]> {
        const res = await this.http.get(`${this.exeptionApi}/v1/exemptions/list/${exemptionType}?councilId=${councilId}&limit=1`)
        return res.data.records;
    }

    public async getExeptionById(exeId: number): Promise<Exeption>{
        const res = await this.http.get(`${this.exeptionApi}/v1/exemptions/${exeId}`);
        return res.data;
    }

    public async getPaginatedExecutionTypeExeptions(exemptionType: string, councilId: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Exeption>> {
        const res = await this.http.get(`${this.exeptionApi}/v1/exemptions/list/${exemptionType}?councilId=${councilId}&partial_description=${filter}`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                //filter: filter ? `^partial_description like ${filter.toUpperCase()}` : undefined
            }
        })
        return res.data;

    }

}
